import { render, staticRenderFns } from "./ClientEditComponent.vue?vue&type=template&id=351d9aae"
import script from "./ClientEditComponent.vue?vue&type=script&lang=js"
export * from "./ClientEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientEditComponent.vue?vue&type=style&index=0&id=351d9aae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports